import React, { useState } from 'react'
import moment from 'moment'
import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap'
import FieldError from '../provider/FieldError'

const ProposeVisitModal = ({ isOpen, toggle, onSubmit, suggested }) => {
  const today = moment().format('YYYY-MM-DD')
  const [form, setForm] = useState({ date: '', time: suggested?.time || '' })
  const [errors, setErrors] = useState({})
  const [sending, setSending] = useState(false)

  const change = (field) => ({ target }) => {
    setForm((prev) => ({ ...prev, [field]: target.value }))
    setErrors((prev) => ({ ...prev, [field]: null }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formErrors = {}
    if (!form.date) formErrors.date = 'Elige una fecha.'
    else if (form.date < today) formErrors.date = 'La fecha no puede ser anterior a hoy.'
    if (!form.time) formErrors.time = 'Elige una hora.'
    if (Object.keys(formErrors).length) {
      setErrors(formErrors)
      return
    }

    setSending(true)
    try {
      await onSubmit(form, setErrors)
    } finally {
      setSending(false)
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={sending ? undefined : toggle} centered>
      <Form onSubmit={handleSubmit} noValidate>
        <ModalHeader toggle={sending ? undefined : toggle}>Proponer otra fecha</ModalHeader>
        <ModalBody>
          {suggested?.date && (
            <p className="fs--1 text-600">
              El propietario sugirió el {moment(suggested.date).format('DD/MM/YYYY')} a las {suggested.time}. Propón la fecha y la hora en que sí
              puedes ir; el propietario la tiene que aceptar.
            </p>
          )}
          <Row form>
            <Col sm={6}>
              <FormGroup>
                <Label for="proposal-date">Fecha</Label>
                <Input id="proposal-date" type="date" min={today} value={form.date} invalid={Boolean(errors.date)} onChange={change('date')} />
                <FieldError error={errors.date} />
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <Label for="proposal-time">Hora</Label>
                <Input id="proposal-time" type="time" value={form.time} invalid={Boolean(errors.time)} onChange={change('time')} />
                <FieldError error={errors.time} />
              </FormGroup>
            </Col>
          </Row>
          <FieldError error={errors.status} />
        </ModalBody>
        <ModalFooter>
          <Button color="falcon-default" onClick={toggle} disabled={sending}>
            Cancelar
          </Button>
          <Button type="submit" color="primary" disabled={sending}>
            {sending && <Spinner size="sm" className="mr-2" />}
            Enviar propuesta
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  )
}

export default ProposeVisitModal
